import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from '../../../../common/constants/menu';

const MatchTab = ({ id, sportsType, isEsports = false, fromHome = false }) => {
  const onClickMatchGa = (name) => {
    const type = Menu.score.filter((item) => item.key === sportsType)[0].title;
  };

  return (
    <div className="snb_wrap">
      <ul>
        <li>
          <NavLink
            to={`/match/${sportsType}/${id}/cheer?fromHome=${fromHome}`}
            activeClassName={'selected'}
            className="item"
            onClick={() => onClickMatchGa('응원')}
          >
            응원
          </NavLink>
        </li>
        <li>
          <NavLink
            to={`/match/${sportsType}/${id}/analysis?fromHome=${fromHome}`}
            activeClassName={'selected'}
            className="item"
            onClick={() => onClickMatchGa('분석글')}
          >
            분석글
          </NavLink>
        </li>
        {(sportsType === 'soccer' ||
          sportsType === 'baseball' ||
          sportsType === 'volleyball' ||
          sportsType === 'hockey' ||
          sportsType === 'starcraft' ||
          sportsType === 'football' ||
          sportsType === 'basketball') && (
            <li>
              <NavLink
                to={`/match/${sportsType}/${id}/record?fromHome=${fromHome}`}
                activeClassName={'selected'}
                className="item"
                onClick={() => onClickMatchGa('전력')}
              >
                전력
              </NavLink>
            </li>
          )}
        {!isEsports && (
          <>
            <li>
              <NavLink
                to={`/match/${sportsType}/${id}/odds?fromHome=${fromHome}`}
                activeClassName={'selected'}
                className="item"
                onClick={() => onClickMatchGa('배당')}
              >
                배당
              </NavLink>
            </li>
            {(sportsType === 'baseball' || sportsType === 'basketball') && (
              <li>
                <NavLink
                  to={`/match/${sportsType}/${id}/lineup?fromHome=${fromHome}`}
                  activeClassName={'selected'}
                  className="item"
                  onClick={() => onClickMatchGa('라인업')}
                >
                  라인업
                </NavLink>
              </li>
            )}
          </>
        )}
        <li>
          <NavLink
            to={`/match/${sportsType}/${id}/broadcast?fromHome=${fromHome}`}
            activeClassName={'selected'}
            className="item"
            onClick={() => onClickMatchGa('중계')}
          >
            중계
          </NavLink>
        </li>
        {sportsType === 'baseball' && (
          <li>
            <NavLink
              to={`/match/${sportsType}/${id}/summary?fromHome=${fromHome}`}
              activeClassName={'selected'}
              className="item"
              onClick={() => onClickMatchGa('기록')}
            >
              기록
            </NavLink>
          </li>
        )}
      </ul>
    </div>
  );
};

export default MatchTab;
